/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Criteria } from './Criteria';
import {
    CriteriaFromJSON,
    CriteriaFromJSONTyped,
    CriteriaToJSON,
} from './Criteria';

/**
 * 
 * @export
 * @interface CriteriaTargetGroup
 */
export interface CriteriaTargetGroup {
    /**
     * 
     * @type {Criteria}
     * @memberof CriteriaTargetGroup
     */
    criteria: Criteria;
    /**
     * 
     * @type {Array<string>}
     * @memberof CriteriaTargetGroup
     */
    facility_ids: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CriteriaTargetGroup
     */
    facility_system_tags: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof CriteriaTargetGroup
     */
    facility_custom_tag_ids: Array<string>;
}

/**
 * Check if a given object implements the CriteriaTargetGroup interface.
 */
export function instanceOfCriteriaTargetGroup(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "criteria" in value;
    isInstance = isInstance && "facility_ids" in value;
    isInstance = isInstance && "facility_system_tags" in value;
    isInstance = isInstance && "facility_custom_tag_ids" in value;

    return isInstance;
}

export function CriteriaTargetGroupFromJSON(json: any): CriteriaTargetGroup {
    return CriteriaTargetGroupFromJSONTyped(json, false);
}

export function CriteriaTargetGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): CriteriaTargetGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'criteria': CriteriaFromJSON(json['criteria']),
        'facility_ids': json['facility_ids'],
        'facility_system_tags': json['facility_system_tags'],
        'facility_custom_tag_ids': json['facility_custom_tag_ids'],
    };
}

export function CriteriaTargetGroupToJSON(value?: CriteriaTargetGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'criteria': CriteriaToJSON(value.criteria),
        'facility_ids': value.facility_ids,
        'facility_system_tags': value.facility_system_tags,
        'facility_custom_tag_ids': value.facility_custom_tag_ids,
    };
}

